// This file is generated by bin/generate-theme.ts

const GrayColors = {
  gray50: '#f6f4f3',
  gray100: '#ebe7e5',
  gray200: '#cfc5c0',
  gray300: '#b5aca6',
  gray400: '#9b938d',
  gray500: '#778899',
  gray600: '#756d66',
  gray700: '#5c5651',
  gray800: '#201f1d',
  gray900: '#091521',
  gray1000: '#ffffff',
  gray900Alpha40: '#201f1d66',
  gray1000Alpha80: '#ffffffcc',
} as const;

const PrimaryColors = {
  primary50: '#fff0eb',
  primary400: '#ff6b70',
  primary500: '#ff474e',
} as const;

const SecondaryColors = {
  secondary50: '#f0f1ff',
  secondary400: '#5268ff',
  secondary500: '#4455f2',
} as const;

const OthersColors = {
  othersred: '#e81c1c',
} as const;

export const colors = {
  text: {
    default: GrayColors.gray800,
    descriptive: GrayColors.gray600,
    primary: PrimaryColors.primary500,
    secondary: SecondaryColors.secondary500,
    placeholder: GrayColors.gray300,
    error: OthersColors.othersred,
    inverse: GrayColors.gray1000,
  },
  background: {
    default: GrayColors.gray1000,
    primary: PrimaryColors.primary500,
    secondary: GrayColors.gray800,
    current: GrayColors.gray600,
    weak: GrayColors.gray50,
    tag: SecondaryColors.secondary50,
    error: PrimaryColors.primary50,
    tertiary: SecondaryColors.secondary500,
  },
  border: {
    default: GrayColors.gray200,
    error: OthersColors.othersred,
    primary: PrimaryColors.primary500,
    focus: SecondaryColors.secondary500,
    strong: GrayColors.gray600,
    inverse: GrayColors.gray1000,
    weak: GrayColors.gray50,
  },
  fill: {
    default: GrayColors.gray600,
    primary: PrimaryColors.primary400,
    secondary: SecondaryColors.secondary500,
    inverse: GrayColors.gray1000,
    weak: GrayColors.gray400,
    men: SecondaryColors.secondary400,
    women: PrimaryColors.primary400,
    error: OthersColors.othersred,
  },
};

export type Colors = typeof colors;
